import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import ButtonView from "@ckeditor/ckeditor5-ui/src/button/buttonview";
import Icon from "./icon.svg";
import InsertBootstrapIconCommand from "./command.js";

export default class LSBootstrapIcons extends Plugin {
    static get pluginName() {
        return "LSBootstrapIcons";
    }

    init() {
        const editor = this.editor;

        // Enregistre la commande
        editor.commands.add("insertBootstrapIcon", new InsertBootstrapIconCommand(editor));

        // Schéma du nouvel élément
        editor.model.schema.register("bootstrapIcon", {
            allowWhere: "$text",
            isInline: true,
            isObject: true,
            allowAttributes: ["class"],
        });

        // Upcast (HTML vers modèle)
        editor.conversion.for("upcast").elementToElement({
            view: {
                name: "i",
                classes: /(^|\s)bi\b/,
            },
            model: (viewElement, { writer }) => {
                return writer.createElement("bootstrapIcon", {
                    class: viewElement.getAttribute("class"),
                });
            },
        });

        // Downcast pour édition (modèle → vue de l'éditeur)
        editor.conversion.for("editingDowncast").elementToElement({
            model: "bootstrapIcon",
            view: (modelElement, { writer }) => {
                return writer.createEmptyElement("i", {
                    class: modelElement.getAttribute("class"),
                });
            },
        });

        // Downcast pour data (modèle → HTML final)
        editor.conversion.for("dataDowncast").elementToElement({
            model: "bootstrapIcon",
            view: (modelElement, { writer }) => {
                return writer.createEmptyElement("i", {
                    class: modelElement.getAttribute("class"),
                });
            },
        });

        // Bouton de la toolbar
        editor.ui.componentFactory.add("ls_bootstrap_icons", (locale) => {
            const button = new ButtonView(locale);
            button.set({
                label: "Insérer une icône Bootstrap",
                icon: Icon,
                tooltip: true,
            });

            this.listenTo(button, "execute", () => {
                const event = new CustomEvent("ckInsertBootstrapIcon", {
                    detail: {
                        editor,
                        type: "bootstrap_icon",
                    },
                });
                document.dispatchEvent(event);
            });

            return button;
        });
    }
}
